<nav class="navbar navbar-expand-md fixed-top navbar-dark flex-fill">
  <!-- <button class="sidebar-toggler ml-4" type="button">
    <i class="fa fa-navicon"></i>
  </button> -->
  <!-- header -->
  <div class="navbar-header pl-2 pr-2 ml-3 text-center">
    <a class="navbar-brand m-0 w-100" href="#">
      <!-- <i class="fa fa-flash mr-1"></i> -->      
      <img src="./assets/img/campusnex.png" alt="campusnex logo" width="200px">
      <!--<span><img src={{clientLogo}} alt="client logo" width="200px"></span>-->      
    </a>
  </div>
  <div>
    <a routerLink="/login-oauth" class="btn nav-link font-weight-bold" routerLinkActive="active"> 
      <span class="text-black-bold">ERP Admin-Login</span>
    </a>
  </div>

  <!-- right menu -->
  <!--<div class="collapse navbar-collapse right-nav" id="collapseBasic" [collapse]="isCollapsed">
    <ul class="navbar-nav ">
      <li class="nav-item">
        <a routerLink="/login-oauth" class="btn nav-link font-weight-bold" routerLinkActive="active"> 
          <span class="text-black-bold">ERP Login</span>
        </a>
      </li>
    </ul>
  </div>-->
</nav>